export var LoginFlow = /*#__PURE__*/ function(LoginFlow) {
    LoginFlow["Password"] = "password";
    LoginFlow["OTP"] = "otp";
    LoginFlow["EmailVerification"] = "email-verification";
    LoginFlow["Email"] = "email";
    return LoginFlow;
}({});
export var SetLoginFlow = /*#__PURE__*/ function(SetLoginFlow) {
    SetLoginFlow["FullLogin"] = "fullLogin";
    SetLoginFlow["OtpLogin"] = "otpLogin";
    return SetLoginFlow;
}({});
